import React from 'react';

function Painter(){
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" id="icon"  x="0px" y="0px" viewBox="0 0 124.6 122">
            <g id="painter">
                <path className="st7" d="M68.2,65.3h-1h-8.2h-1.5c-0.7,0-1.4,0.6-1.4,1.4v51.2c0,0.7,0.6,1.4,1.4,1.4h10.8c0.7,0,1.4-0.6,1.4-1.4V66.6
                    C69.5,65.9,68.9,65.3,68.2,65.3z"/>
                <polyline className="st7" points="58.9,65.3 58.9,65 58.9,60.4 62.9,60.4 67.1,60.4 67.1,64.8 67.1,65.3 	"/>
                <path className="st7" d="M62.9,60.4v-9.3c0,0,0-0.6,3.1-0.4h49.5c0,0,7.7-1,6.9-9.4V26.4c0,0-2.1-5.2-10.7-4.2h-0.8v6.1h-6.3V15.8h6
                    h0.4l0,6.4"/>
                <polyline className="st7" points="104.6,15.8 104.6,10.3 8.7,10.3 8.7,16 2.5,16 2.5,28.6 8.7,28.6 8.7,16 	"/>
                <polyline className="st7" points="38.7,28.6 38.7,34.5 42,34.5 81.3,34.5 104.6,34.5 104.6,28.3 	"/>
                <path className="st8" d="M23.3,46.2h-1c-0.7,0-1.2-0.6-1.2-1.2V33.8c0-0.7,0.6-1.2,1.2-1.2h1c0.7,0,1.2,0.6,1.2,1.2V45
                    C24.6,45.6,24,46.2,23.3,46.2z"/>
                <path className="st8" d="M31.3,36.4h-1c-0.7,0-1.3-0.6-1.3-1.3v-3.6c0-0.7,0.6-1.3,1.3-1.3h1c0.7,0,1.3,0.6,1.3,1.3v3.6
                    C32.5,35.8,32,36.4,31.3,36.4z"/>
                <path className="st7" d="M8.7,28.6c0,0-0.8,6.5,4.7,5.9v16.2c0,0,0.9,6.3,6.8,4.9l1.6-0.9v9.9c0,0,2.5,3.3,5.1,2.7c0,0,2.9,0.1,3.2-4.5
                    V43.4c0,0,4.9,5.8,8.4-1.4c0,0,0.4-2.9,0.2-5.7V35l0-0.5"/>
                <path className="st7" d="M21.8,54.8c0,0,1.3-2,1.2-4.8"/>
            </g>
        </svg>

    )
}

export default Painter;